import React from 'react';
import TechEcosystemComponent from '../components/TechEcosystem/TechEcosystem';

/**
 * TechnologyEcosystemPage - Technology Ecosystem page wrapper
 */
export default function TechnologyEcosystemPage() {
  return <TechEcosystemComponent />;
}
